import { render, staticRenderFns } from "./PricingRules.vue?vue&type=template&id=67b3c4e2&scoped=true&"
import script from "./PricingRules.vue?vue&type=script&lang=js&"
export * from "./PricingRules.vue?vue&type=script&lang=js&"
import style0 from "./PricingRules.vue?vue&type=style&index=0&id=67b3c4e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b3c4e2",
  null
  
)

export default component.exports